import React from "react";
import { ChevronRight } from "lucide-react";
import { cn } from "@/lib/utils";
import { textSizeStyles } from "./CategoryPath.styles";
import type { CategoryPathProps } from "./CategoryPath.types";

export const CategoryPath: React.FC<CategoryPathProps> = ({
  path,
  size = "sm",
}) => {
  if (!path) {
    return (
      <span className="text-slate-400 dark:text-slate-500 italic text-sm">
        Not mapped
      </span>
    );
  }

  const parts = path.split(".");
  const textSize = textSizeStyles[size];

  return (
    <div className={cn("flex items-center flex-wrap gap-1", textSize)}>
      {parts.map((part, idx) => (
        <React.Fragment key={idx}>
          {idx > 0 && (
            <ChevronRight className="w-3 h-3 text-slate-400 dark:text-slate-500 shrink-0" />
          )}
          <span
            className={cn(
              "font-medium",
              idx === parts.length - 1
                ? "text-indigo-600 dark:text-indigo-400"
                : "text-slate-500 dark:text-slate-400",
            )}
          >
            {part}
          </span>
        </React.Fragment>
      ))}
    </div>
  );
};
